var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reset-page" },
    [
      _c("h4", { staticClass: "pa-4 white--text text-center" }, [
        _vm._v("\n    " + _vm._s(_vm.text1) + " "),
        _c("br"),
        _vm._v("\n    " + _vm._s(_vm.text2) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "secondary white--text",
          attrs: { rounded: "", large: "", loading: _vm.loading },
          on: {
            click: function ($event) {
              return _vm.gotoAsta()
            },
          },
          scopedSlots: _vm._u([
            {
              key: "loader",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "spinner",
                    attrs: {
                      src: _vm.firebase_host + "/static/gif/circle.gif",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(_vm._s(_vm.btnText) + "\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }